import Component from '@glimmer/component';

import { registerDestructor } from '@ember/destroyable';
import { action } from '@ember/object';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import didUpdate from '@ember/render-modifiers/modifiers/did-update';

import { call, pipe } from 'rise-ui/utils/function.js';

export default class CIdentityComponent extends Component {
  constructor() {
    super(...arguments);

    registerDestructor(this, () => {
      this.addBlockManager().forEach(([ listener, ...args ]) =>
        call(listener.onDestroy, this, ...args)
      );
    });
  }

  @action
  addManagerListener(manager, listeners = [ [ this.args ] ]) {
    if (manager) {
      if (!Array.isArray(manager)) {
        manager = [ manager ];
      }
      listeners.push(manager);
    }
    return listeners;
  }

  @action
  addLifecycleManager(listeners = undefined) {
    return this.addManagerListener(this.args.lifecycleManager, listeners);
  }

  @action
  addBlockManager(listeners = undefined) {
    return this.addManagerListener(this.args.blockManager, listeners);
  }

  getInitListeners() {
    return pipe(this.addLifecycleManager, this.addBlockManager)();
  }

  getBlockListeners() {
    return this.addBlockManager();
  }

  @action
  didInsertComponent(el, [ hasBlock ]) {
    el.remove();
    this.getInitListeners().forEach(([ listener, ...args ]) =>
      call(listener.onInit, this, ...args, { hasBlock })
    );
    this.didUpdateBlock(hasBlock);
  }

  @action
  didUpdateBlock(hasBlock) {
    this.getBlockListeners().forEach(([ listener, ...args ]) =>
      call(listener.onHasBlock, this, ...args, hasBlock)
    );
  }

  <template>
    <span
      {{didInsert this.didInsertComponent (has-block)}}
      {{didUpdate this.didUpdateBlock (has-block)}}
      ...attributes
    ></span>
    {{~yield~}}
  </template>
}
